export default class Arc {
    constructor(a0, a1) {
        /**
         * @type {number}
         */
        this.a0 = a0;
        /**
         * @type {number}
         */
        this.a1 = a1;
    }
}